import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"


import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
// import { deleteSingleCategories, getAllCategories } from "../../assets/api/super-admin"
import { toast } from "react-toastify"

import Loading from "../../components/loading/loading"
import ConfirmDeleteModal from "../../components/modal/confirm-delete/confirmDelete"

import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { ReactComponent as Filter } from "../../assets/icons/shapes/filter.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleDiscount, getAllDiscounts, getAllUsedDiscountsUsers } from "../../api/discounts"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"

const Discounts = () => {

    const naviagte = useNavigate()
    const [activeTab, setActiveTab] = useState(0)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)



    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.code + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }

    
    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading: discountLoading, refetch } = Query(
        ['getAllDiscounts', searchKeyword, page],
        () => getAllDiscounts(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );
    const { data: usedDiscountsData, isLoading } = Query(
        ['getAllUsedDiscountsUsers'],
        () => getAllUsedDiscountsUsers(),
        { enabled: activeTab === 1 }
    );


    const { mutate: deleteMutate } = Mutate(
        "deleteDiscount",
        deleteSingleDiscount,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout title={"تخفیف ها"} buttonTitle={"تخفیف جدید"} buttonLink={"/admin/discounts/create"} >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse wsm:!text-[9px]">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278] ">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>تخفیف های استفاده شده</button>
                        <button onClick={() => setActiveTab(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>جدید ترین</button>
                        <button onClick={() => setActiveTab(3)} className={activeTab === 4 ? "bg-white rounded-lg text-black" : ""}>قدیمی ترین</button>
                    </div>
                    <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو تخفیف ها ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div>
                </div>
                {activeTab === 0 &&

                    <table className="table-auto transition-all wsm:!text-[9px]" >
                        <thead className="!py-2">
                            <tr className=" border-b border-black">
                                <th className="py-3">#</th>
                                <th className="py-3">کد تخفیف</th>
                                <th className="py-3">محدودیت استفاده</th>
                                <th className="py-3">نوع</th>
                                <th className="py-3">مقدار تخفیف</th>
                                <th className="py-3">تاریخ انقضاء</th>
                                <th className="py-3">عملیات</th>
                            </tr>
                        </thead>
                        {
                            !discountLoading &&
                            <tbody>
                                {
                                    data?.data?.length ?
                                        data?.data?.map(el => (
                                            <tr key={el.id} className=" text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.id}</td>
                                                <td className="text-center py-5" > {el.code}</td>
                                                <td className="text-center py-5" > {el.use_limit}</td>
                                                <td className="text-center py-5" > {el.type === "private" ? "خصوصی" : "عمومی"}</td>
                                                <td className="text-center py-5 " >
                                                    <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                        {
                                                            !el.amount && !el.percent ?
                                                                "نامحدود"
                                                                :
                                                                el.amount ? el.amount.toLocaleString() + " تومان" : el.percent + " %"
                                                        }
                                                        {/* el.amount
                                                        {el.amount ? el.amount + " ریال" : el.percent + " %"} */}
                                                    </div>
                                                </td>
                                                <td className="text-center py-5" >
                                                    {
                                                        el.expire_date ?
                                                            <>
                                                                <p>{el.expire_date?.split(" ")[0]}</p>
                                                                <p>{el.expire_date?.split(" ")[1]}</p>
                                                            </>
                                                            :
                                                            <p>نامحدود</p>
                                                    }
                                                </td>
                                                <td className="text-center py-5" >
                                                    <div className="flex justify-evenly items-center wsm:!justify-between">
                                                        <div className=" cursor-pointer " onClick={() => naviagte("/admin/discounts/edit/" + el.id)}><Edit width={"20"} className="wsm:!w-3" height="20" /></div>
                                                        <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "تخفیف") }}><Delete className="wsm:!w-3" width={"20"} height="20" /></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <div>
                                            <p>هیچ دسته بندی پیدا نشد</p>
                                        </div>
                                }
                            </tbody>
                        }
                    </table>
                }
                {
                    activeTab === 1 &&
                    <table className="table-auto transition-all" >
                        <thead className="!py-2">
                            <tr className=" border-b border-black">
                                <th className="py-3">#</th>
                                <th className="py-3">نام و نام خانوادگی</th>
                                <th className="py-3">شماره تلفن</th>
                                <th className="py-3">کد تخفیف استفاده شده</th>
                                <th className="py-3">تاریخ استفاده</th>
                            </tr>
                        </thead>
                        {
                            !isLoading &&
                            <tbody>
                                {
                                    usedDiscountsData?.data?.length ?
                                        usedDiscountsData?.data?.map(el => (
                                            <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.user?.id}</td>
                                                <td className="text-center py-5" > {el.user?.name + " " + el.user?.lastname}</td>
                                                <td className="text-center py-5" > {el.user?.phone}</td>
                                                <td className="text-center py-5" > {el.discount?.code}</td>
                                                <td className="text-center py-5" > {el.used_at}</td>

                                            </tr>
                                        ))
                                        :
                                        <div>
                                            <p>هیچ دسته بندی پیدا نشد</p>
                                        </div>
                                }
                            </tbody>
                        }
                    </table>
                }

                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
    )
}

export default Discounts